export default {
  title: "Settings",
  languages: {
    en: "English",
    es: "Spanish",
  },
  mode: {
    title: "Mode",
    light: "Light",
    dark: "Dark",
  },
}
